import { render, staticRenderFns } from "./18.vue?vue&type=template&id=231df7ba&scoped=true&"
import script from "./18.vue?vue&type=script&lang=js&"
export * from "./18.vue?vue&type=script&lang=js&"
import style0 from "./18.vue?vue&type=style&index=0&id=231df7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231df7ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231df7ba')) {
      api.createRecord('231df7ba', component.options)
    } else {
      api.reload('231df7ba', component.options)
    }
    module.hot.accept("./18.vue?vue&type=template&id=231df7ba&scoped=true&", function () {
      api.rerender('231df7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/18.vue"
export default component.exports